exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.bottom-menu[data-v-7d6c1bf8]{background-color:#0c2340;position:fixed;bottom:0;width:100%;color:#fff}div .fixed-content[data-v-7d6c1bf8]{position:relative;padding:11px 0}", ""]);

// exports
